// extracted by mini-css-extract-plugin
export default {"container":"q74el0"};